module.exports = __webpack_public_path__ + "img/icon-qizhi-hover.6f346f67.svg";